import React from "react";
import {
  INSTALLED_ALTERED_RELOCATED_REMOVED,
  SIGNIFICAT_DEVIATION,
  TEMPORARY_OR_PERMANENT,
  TIME_LIMIT_FOR_GROUND_COVER,
  YES_NO,
} from "../constant/constant";
import { getFormatedDate } from "./helper";

const generateUniqueId = () => {
  const date = new Date();
  return `${date.getFullYear()}-${(date.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${date
    .getDate()
    .toString()
    .padStart(2, "0")}-${date.getTime()}-${Math.floor(Math.random() * 1000)}`;
};

export const generateInspectionGroundStabilization = (numObjects) => {
  const newObjects = [];
  for (let i = 0; i < numObjects; i++) {
    newObjects.push({
      id: generateUniqueId(),
      area: "",
      timeLimit: 0,
      isStabilizationInstalled: null,
      stabilization: 0,
      groundCover: 0,
      inspectionDate: "",
      describeAction: "",
      dateCorrecion: "",
    });
  }

  return newObjects;
};

export const generateSwInspectionObservation = (numObjects) => {
  const newObjects = [];
  for (let i = 0; i < numObjects; i++) {
    newObjects.push({
      id: generateUniqueId(),
      dischargeOutfall: "",
      anyIncreaseInStream: 0,
      anyVisibleOil: 0,
      anyVisibleErosion: 0,
      anyVisibleSedimentation: 0,
      inspectionDate: "",
      recommendation: "",
      dateCorrection: "",
    });
  }
  return newObjects;
};

export const generateSwInspectionLotDisturbance = (numObjects) => {
  const newObjects = [];

  for (let i = 0; i < numObjects; i++) {
    newObjects.push({
      id: generateUniqueId(),
      lotNumber: "",
      disturbanceDate: "",
      erosionControlDate: "",
    });
  }
  return newObjects;
};

export const generateSwInspectionNewOrRevisedMeasures = (numObjects) => {
  const newObjects = [];

  for (let i = 0; i < numObjects; i++) {
    newObjects.push({
      id: generateUniqueId(),
      locationAndDesc: "",
      proposedDimension: "",
      actualDimension: "",
      significantDeviation: 0,
      measureDate: "",
      measureType: 0,
    });
  }
  return newObjects;
};

export const generateSwInspectionNPDES = (numObjects) => {
  const newObjects = [];

  for (let i = 0; i < numObjects; i++) {
    newObjects.push({
      id: generateUniqueId(),
      date: "",
      time: "",
      duration: "",
      precipitationAmount: "",
      discharge: null,
      locationOfDischarge: "",
    });
  }
  return newObjects;
};

export const processCategories = (categories) => {
  return categories?.map((x) => ({
    isSkipped: false,
    categoryId: x.key,
    sequenceNumber: x.sequenceNumber,
    listInspectionSubCategory: processSubCategories(
      x.listInspectionSubCategory,
    ),
  }));
};

const processSubCategories = (subCategories) => {
  return subCategories?.map((y) => ({
    isSkipped: false,
    subCategoryId: y.key,
    sequenceNumber: y.sequenceNumber,
    listInspectionQuestionAnswer: processQuestionAnswers(
      y.listInspectionQuestionAnswer,
    ),
  }));
};

const processQuestionAnswers = (questionAnswers) => {
  return questionAnswers.map((z) => ({
    sequenceId: z.quesNo,
    answerMstId: z.radioSelectiovalue
      ? parseInt(z.radioSelectiovalue)
      : z.responseType === 2
        ? 4
        : null,
    questionId: parseInt(z.key),
    listInspectionQuestionAnswerDet: processQuestionDetails(
      z.notAcceptableList,
      z,
    ),
  }));
};

const processQuestionDetails = (detailsList, z) => {
  if (z?.responseType === 2) {
    const detailItem = {
      details: z.textValueQuestion,
      itemFoundId: z.itemFoundKey || z.itemFoundKey || null,
      listInspectionDetailsLocation: processLocationDetails(
        z.addLocatioList,
        z,
      ),
    };
    return [detailItem];
  } else {
    return detailsList?.map((detail) => {
      const detailItem = {
        details: detail.itemDetails,
        itemFoundId: detail.itemFoundKey || z.itemFoundKey || null,
        listInspectionDetailsLocation: processLocationDetails(
          detail.addLocatioList,
          z,
        ),
      };
      return detailItem;
    });
  }
};

const processLocationDetails = (locationList, z) => {
  return locationList
    ?.map((location) => {
      if (
        location.textVaue !== undefined &&
        parseInt(z.radioSelectiovalue) === 2
      ) {
        return {
          location: location.textVaue,
          files: [
            {
              subrootId: null,
              fileId: location.addLocatioImgId
                ? parseInt(location.addLocatioImgId)
                : location.fileId
                  ? parseInt(location.fileId)
                  : 0,
            },
          ],
        };
      }
      return null;
    })
    .filter((item) => item !== null);
};

export const processRainfallData = (rainfallData) => {
  return rainfallData?.map((item) => {
    const newItem = { ...item };
    const fieldsToRemove = [
      "projectNumber",
      "projectName",
      "projectId",
      "precipId",
      "precipDateFormat",
      "precipDate",
      "precipAmt",
      "organisationName",
      "organisationId",
      "isRainfallAboveThreshold",
      "exceedance",
      "evenTrackPrecipAmt",
      "accountId",
    ];
    fieldsToRemove?.forEach((field) => {
      delete newItem[field];
    });

    return newItem;
  });
};

export const processProjectPhaseData = (projectPhaseData) => {
  return projectPhaseData?.map((item) => {
    const newItem = { ...item };
    const fieldsToRemove = ["value", "key"];
    fieldsToRemove?.forEach((field) => {
      delete newItem[field];
    });

    return newItem;
  });
};
export const processSiteComplianceData = (siteComplianceData) => {
  return siteComplianceData?.map((item, index, array) => {
    const newItem = { ...item };
    const fieldsToRemove = ["value", "key"];
    fieldsToRemove.forEach((field) => {
      delete newItem[field];
    });
    newItem.isChecked = index === array.length - 1 ? null : item.siteAns;
    newItem.comment = item.siteComment;

    delete newItem.siteAns;
    delete newItem.siteComment;

    return newItem;
  });
};

export const listInspectionCategoryObject = (data) => {
  return data.questionSetCatDetails.map((categoryItem) => {
    return {
      key: categoryItem.key,
      value: categoryItem.value,
      catPercent: 0,
      howManyCat: 0,
      catAns: false,
      catError: false,
      sequenceNumber: categoryItem.sequenceNumber,
      listInspectionSubCategory: categoryItem.subcategories.map(
        (subCategoryItem) => {
          return {
            key: subCategoryItem.key,
            isAnswerCat: false,
            subCatError: false,
            howManySub: 0,
            value: subCategoryItem.value,
            subPercent: 0,
            sequenceNumber: subCategoryItem.sequenceNumber,

            showBth: subCategoryItem.questions.every(
              (findItem) =>
                findItem.responseType === 1 || findItem.responseType === 3,
            ),
            listInspectionQuestionAnswer: subCategoryItem.questions
              .filter((x) => x.isSelected)
              .map((questionItem) => {
                return {
                  key: questionItem.key,
                  isAnswerSubCat: false,
                  quesNo: questionItem.quesNo,
                  value: questionItem.value,
                  options: questionItem.options,
                  responseType: questionItem.responseType,
                  questionSequenceNumber: questionItem.questionSequenceNumber,
                  radioSelectiovalue: "",
                  textValueQuestion: "",
                  notAcceptableList:
                    questionItem.responseType !== 2
                      ? [
                          {
                            id: Date.now() + Math.floor(Math.random() * 100),
                            itemFound: "",
                            itemDetails: "",
                            itemFoundValue: "",
                            itemFoundKey: "",
                            addLocationText: "",
                            addLocatioImg: "",
                            addLocatioImgId: "",
                            addLocatioList: [],
                          },
                        ]
                      : [],
                };
              }),
          };
        },
      ),
    };
  });
};

export const updateCategoryPercent = (category) => {
  const perQuestionCat = 100 / category?.listInspectionSubCategory?.length;
  const completedCat = category.listInspectionSubCategory.filter(
    (items) => items.isAnswerCat,
  );
  category.catPercent = perQuestionCat * completedCat?.length;
  category.howManyCat = completedCat?.length;
  category.catAns = true;
};

export const updateSubCategoryPercent = (subCategory) => {
  const perQuestionSub =
    100 / subCategory?.listInspectionQuestionAnswer?.length;
  const completedSub = subCategory.listInspectionQuestionAnswer.filter(
    (items) => items.isAnswerSubCat,
  );
  subCategory.subPercent = perQuestionSub * completedSub?.length;
  subCategory.howManySub = completedSub?.length;
  subCategory.subCatAns = true;
};

export const updateQuestion = (
  question,
  targetValue,
  targetName,
  questionValue,
  event,
  setAcceptable,
) => {
  if (targetName === "allAcceptable") {
    event.stopPropagation();
    question.isAnswerSubCat = true;
    question.radioSelectiovalue = "1";
  }
  if (targetName === "notApplicable") {
    event.stopPropagation();
    question.isAnswerSubCat = true;
    question.radioSelectiovalue = "3";
  }
  if (question?.key == questionValue?.key) {
    question.isAnswerSubCat = true;
    if (targetName === "radio") {
      question.radioSelectiovalue = targetValue;
      if (targetValue === "2") {
        setAcceptable(questionValue?.key);
      }
    }
    if (targetName === "questionV") {
      question.textValueQuestion = targetValue;
    }
    if (targetName == "appendFrom") {
      question.notAcceptableList.push({
        id: Date.now() + Math.floor(Math.random() * 100),
        itemFound: "",
        itemDetails: "",
        itemFoundValue: "",
        itemFoundKey: "",
        addLocationText: "",
        addLocatioImg: "",
        addLocatioImgId: "",
        addLocatioList: [],
      });
    }
  }
};

export const validateInspectionCategories = (
  listInspectionCategory,
  setListInspectionCategory,
) => {
  const listInspectionCategoryClone = [...listInspectionCategory];
  let isError = false;

  listInspectionCategoryClone.forEach((cat) => {
    if (!cat.catAns) {
      cat.catError = true;
      isError = true;
    } else {
      cat.catError = false;
    }

    cat.listInspectionSubCategory.forEach((sub) => {
      if (
        sub.listInspectionQuestionAnswer?.some((item) =>
          parseInt(item?.responseType) === 2
            ? !item.textValueQuestion
            : !item.radioSelectiovalue,
        )
      ) {
        sub.subCatError = true;
        isError = true;
      } else {
        sub.subCatError = false;
      }

      sub.listInspectionQuestionAnswer.forEach((question) => {
        if (parseInt(question.radioSelectiovalue) === 2) {
          question.notAcceptableList?.forEach((notAcc) => {
            if (!notAcc.itemFoundKey) {
              notAcc.itemFoundError = true;
              isError = true;
            } else {
              notAcc.itemFoundError = false;
            }

            if (!notAcc.addLocatioList || notAcc.addLocatioList.length === 0) {
              notAcc.addLocationDetailError = true;
              isError = true;
            } else {
              notAcc.addLocationDetailError = false;
            }
          });
        }
      });
    });
  });

  if (isError) {
    setListInspectionCategory(listInspectionCategoryClone);
  }

  return isError;
};

export const rainfallColumns = [
  { label: "Day/Date", key: "day", className: "" },
  { label: "Rain Amount (in.)", key: "rainfallAmt", className: "" },
  { label: "Initials", key: "initials", className: "" },
  {
    label: (
      <div style={{ textAlign: "center" }}>
        Notes:
        <br />
        Daily Rainfall Required. Except for Holidays or Weekends. If no rain,
        indicate with a "zero"
      </div>
    ),
    key: "notes",
    className: "",
  },
];

export const phaseProjectColumns = [
  {
    label:
      "Phase of Grading (Construction) (Place a check in the box of the current project phase)",
    key: "optionName",
    className: "phaseProjectWidth",
  },
  { key: "isChecked", label: "" },
  { label: "Comments:", key: "comment", className: "" },
];
export const siteComplianceAnsViewColumns = [
  {
    label: "Check the box if the following  items are on-site:",
    key: "value",
    className: "phaseProjectWidth",
  },
  { key: "siteAns", label: "" },
];
export const groundStabilizationColumns = [
  {
    label:
      "Site area description and location where activities have temporarily or permanently ceased",
    key: "area",
    className: "",
  },
  {
    label: "Time Limit for Ground Cover 7 days or 14 days",
    key: "timeLimit",
    className: "",
  },
  {
    label: "Have stabilization measures been installed?",
    key: "isStabilizationInstalled",
    className: "",
  },
  {
    label: "Temporary or Permanent Stabilization",
    key: "stabilization",
    className: "",
  },
  {
    label: "Ground Cover Sufficient to Restrain Erosion?(Y/N)",
    key: "groundCover",
    className: "",
  },
  { label: "Original Inspection Date", key: "inspectionDate", className: "" },
  { label: "Describe Actions Needed", key: "describeAction", className: "" },
  { label: "Date Corrections Verified", key: "dateCorrecion", className: "" },
];

export const observationColumns = [
  {
    label: "Stormwater Discharge Outfall ID or Location",
    key: "dischargeOutfall",
    className: "",
  },
  {
    label: "Any Increase in Stream Turbidity from Discharge?",
    key: "anyIncreaseInStream",
    className: "",
  },
  {
    label:
      "Any visible oil sheen, floating or suspended solids or discoloration?",
    key: "anyVisibleOil",
    className: "",
  },
  {
    label: "Any Visible Erosion below SDO?",
    key: "anyVisibleErosion",
    className: "",
  },
  {
    label:
      "Any Visible Sedimentation in Streams, Wetlands or Outside Site Limits?",
    key: "anyVisibleSedimentation",
    className: "",
  },
  {
    label: "Inspection Date",
    key: "inspectionDate",
    className: "",
  },
  {
    label: "Describe Actions Needed",
    key: "recommendation",
    className: "",
  },
  {
    label: "Date Corrections Verified",
    key: "dateCorrection",
    className: "",
  },
];

export const lotDisturbanceColumns = [
  { label: "Lot Number", key: "lotNumber", className: "" },
  {
    label: "Date Lot Noted as Active",
    key: "disturbanceDate",
    className: "",
  },
  {
    label: "Date Lot Noted as Stabilized",
    key: "erosionControlDate",
    className: "",
  },
];
export const getValueByKey = (key) => {
  const result = YES_NO?.find((item) => item.key === key);
  if (result) {
    return result.value === 0 || result.value === null || result.value === ""
      ? "N/A"
      : result.value;
  } else if (key === 0) {
    return "N/A";
  }
  return key;
};

export const transformSoilType = (soilTypeId) => {
  if (soilTypeId === 6) return "Wet";
  if (soilTypeId === 7) return "Dry";
  if (soilTypeId === 8) return "Frozen";
  return "";
};

export const transformSampleTaken = (isSampleTaken) => {
  if (isSampleTaken === null) return null;
  return isSampleTaken ? "3" : "1";
};

export const transformProjectStatus = (projectStatus) => {
  return projectStatus ? "1" : "2";
};

export const transformCategoryData = (categoryData, prevEditMode = false) => {
  return categoryData.map((category) => {
    category.categoryId = category.key;
    category.catAns = category?.subcategoriesView?.some(
      (itemss) => itemss.isAnswerGiven,
    );
    const perQuestionCat = 100 / category?.subcategoriesView?.length;
    const completedCat = category.subcategoriesView?.filter(
      (items) => items.isAnswerGiven,
    );
    category.catPercent = perQuestionCat * completedCat?.length;
    category.howManyCat = completedCat?.length;

    category.listInspectionSubCategory = category.subcategoriesView.map(
      (subcategory) => {
        subcategory.subCategoryId = subcategory.key;
        subcategory.subCatAns = subcategory?.insQuesAnsReportView?.some(
          (items) => items.answerMstId,
        );
        const perQuestionSub = 100 / subcategory?.insQuesAnsReportView?.length;
        const completedSub = subcategory.insQuesAnsReportView.filter(
          (items) => items.answerMstId,
        );
        subcategory.subPercent = perQuestionSub * completedSub?.length;
        subcategory.howManySub = completedSub?.length;

        subcategory.showBth = subcategory?.insQuesAnsReportView?.some(
          (findItem) => (findItem?.answerMstId === 4 ? false : true),
        );
        subcategory.listInspectionQuestionAnswer =
          subcategory.insQuesAnsReportView.map((questions) => {
            questions.questionSequenceNumber = questions.sequenceId;
            questions.key = questions.questionId;
            questions.value = questions.question;
            questions.radioSelectiovalue = questions.answerMstId;
            questions.textValueQuestion =
              questions.detailsReportView[0]?.details;
            questions.notAcceptableList =
              questions.responseType === 1 || questions.responseType === 3
                ? questions.detailsReportView?.length > 0
                  ? prevEditMode
                    ? questions.detailsReportView.map((notAcc) => {
                        notAcc.id =
                          Date.now() + Math.floor(Math.random() * 100);
                        notAcc.itemFoundKey = notAcc.itemFoundId;
                        notAcc.itemFoundValue = notAcc.itemFound;
                        notAcc.itemDetails = notAcc.details;
                        notAcc.addLocatioList = notAcc.locationsReportView?.map(
                          (locationV) => {
                            locationV.textVaue = locationV.location;
                            locationV.id = locationV.locationId;
                            locationV.imgUrl = locationV.files[0]?.filePath;
                            locationV.addLocatioImgId =
                              locationV.files[0]?.fileId;
                            return locationV;
                          },
                        );
                        return notAcc;
                      })
                    : []
                  : []
                : [];
            return questions;
          });
        return subcategory;
      },
    );
    return category;
  });
};

export const getQuestionIdsFromCategories = (categories) => {
  return categories
    ?.map((category) =>
      category?.subcategoriesView?.flatMap((subcategory) =>
        subcategory?.insQuesAnsReportView?.map(
          (question) => question.questionId,
        ),
      ),
    )
    .flat()
    .filter((id) => id !== undefined);
};

export const getDayByKey = (key) => {
  const result = TIME_LIMIT_FOR_GROUND_COVER?.find((item) => item.key === key);
  if (result) {
    if (parseInt(result.value) === 1) {
      return "7 days";
    } else if (parseInt(result.value) === 2) {
      return "14 days";
    }
    return result.value === 0 || result.value === null || result.value === ""
      ? "N/A"
      : result.value;
  } else {
    return "N/A";
  }
};

export const getTemporaryPermanent = (key) => {
  const result = TEMPORARY_OR_PERMANENT?.find((item) => item.key === key);
  if (result) {
    if (parseInt(result.value) === 1) {
      return "Temporary";
    } else if (parseInt(result.value) === 2) {
      return "Permanent";
    }
    return result.value === 0 || result.value === null || result.value === ""
      ? "N/A"
      : result.value;
  } else {
    return "N/A";
  }
};

export const getMeasureType = (key) => {
  const result = INSTALLED_ALTERED_RELOCATED_REMOVED?.find(
    (item) => item.key === key,
  );
  if (result) {
    if (parseInt(result.value) === 2) {
      return "Installed";
    } else if (parseInt(result.value) === 1) {
      return "Altered";
    } else if (parseInt(result.value) === 3) {
      return "Relocated";
    } else if (parseInt(result.value) === 4) {
      return "Removed";
    }
    return result.value === 0 || result.value === null || result.value === ""
      ? "N/A"
      : result.value;
  } else {
    return "N/A";
  }
};

export const getSignificantDeviation = (key) => {
  const result = SIGNIFICAT_DEVIATION?.find(
    (item) => parseInt(item.key) === parseInt(key),
  );
  if (result) {
    return result.value === 0 || result.value === null || result.value === ""
      ? "N/A"
      : result.value;
  }
  return key;
};

export const validateSwInspectionLotDisturbance = (lotDisturbance) => {
  return lotDisturbance
    .filter((item) => {
      return !isLotDisturbanceRowEmpty(item);
    })
    ?.map((item) => {
      if (item.disturbanceDate !== null) {
        item.disturbanceDate = getFormatedDate(item.disturbanceDate);
      }
      if (item.erosionControlDate !== null) {
        item.erosionControlDate = getFormatedDate(item.erosionControlDate);
      }
      return item;
    });
};

export const validateSwInspectionObservation = (swInspectionObservation) => {
  return swInspectionObservation
    .filter((item) => {
      return !isObservationRowEmpty(item);
    })
    ?.map((item) => {
      if (item.inspectionDate !== "") {
        item.inspectionDate = getFormatedDate(item.inspectionDate);
      }
      if (item.dateCorrection !== "") {
        item.dateCorrection = getFormatedDate(item.dateCorrection);
      }

      return item;
    });
};

export const validateSwInspectionNewOrRevisedMeasures = (
  swInspectionNewOrRevisedMeasures,
) => {
  return swInspectionNewOrRevisedMeasures
    .filter((item) => {
      return !isNewOrRevisedMeasuresRowEmpty(item);
    })
    ?.map((item) => {
      if (item.measureDate !== "") {
        item.measureDate = getFormatedDate(item.measureDate);
      }
      return item;
    });
};

export const validateSwInspectionGroundStabilization = (
  swInspectionGroundStabilization,
) => {
  return swInspectionGroundStabilization
    ?.filter((item) => {
      return !isGroundStabilizationRowEmpty(item);
    })
    ?.map((item) => {
      if (item.inspectionDate !== "") {
        item.inspectionDate = getFormatedDate(item.inspectionDate);
      }
      if (item.dateCorrecion !== "") {
        item.dateCorrecion = getFormatedDate(item.dateCorrecion);
      }
      item.isStabilizationInstalled =
        parseInt(item.isStabilizationInstalled) === 1
          ? true
          : parseInt(item.isStabilizationInstalled) === 2
            ? false
            : null;

      return item;
    });
};

export const ViewPastRainFallColumns = [
  {
    label: "Date",
    key: "precipDateFormat",
    className: "",
  },
  {
    label: "Rain Amount (in)",
    key: "evenTrackPrecipAmt",
    className: "",
  },
];

export const RevisedMeasuresColumns = [
  {
    label: "Measure ID or Location and Description",
    key: "locationAndDesc",
    className: "",
  },
  {
    label: "Proposed Dimensions",
    key: "proposedDimension",
    className: "",
  },
  {
    label: "Actual Dimensions (ft)",
    key: "actualDimension",
    className: "",
  },
  {
    label: "Significant Deviation from plan?",
    key: "significantDeviation",
    className: "",
  },
  {
    label:
      "Date Measure observed as installed, altered, relocated, or removed.",
    key: "measureDate",
    className: "",
  },
  {
    label: "Installed, Altered, Converted, Relocated, or Removed.",
    key: "measureType",
    className: "",
  },
];

export const isExtraContent = (value) => {
  return String(value || "")?.length > 40;
};

const hasAnyData = (item) => {
  return (
    (item.date && item.date !== "") ||
    (item.time && item.time !== "") ||
    (item.duration && item.duration !== "") ||
    (item.precipitationAmount && item.precipitationAmount !== "") ||
    (item.discharge !== null && item.discharge !== "") ||
    (item.locationOfDischarge && item.locationOfDischarge !== "")
  );
};

const isRowComplete = (item) => {
  return (
    item.date &&
    item.date !== "" &&
    item.time &&
    item.time !== "" &&
    item.duration &&
    item.duration !== "" &&
    item.precipitationAmount &&
    item.precipitationAmount !== "" &&
    item.discharge !== null &&
    item.discharge !== "" &&
    item.locationOfDischarge &&
    item.locationOfDischarge !== ""
  );
};

const validateRowCompleteness = (item, index) => {
  const hasData = hasAnyData(item);
  const isComplete = isRowComplete(item);

  if (hasData && !isComplete) {
    const missingFields = [];
    if (!item.date || item.date === "") missingFields.push("Date");
    if (!item.time || item.time === "") missingFields.push("Time");
    if (!item.duration || item.duration === "") missingFields.push("Duration");
    if (!item.precipitationAmount || item.precipitationAmount === "")
      missingFields.push("Precipitation Amount");
    if (item.discharge === null || item.discharge === "")
      missingFields.push("Discharge");
    if (!item.locationOfDischarge || item.locationOfDischarge === "")
      missingFields.push("Location of Discharges");

    return {
      isValid: false,
      rowIndex: index + 1,
      missingFields: missingFields,
    };
  }

  return { isValid: true };
};

export const validateSwInspectionNPDES = (swInspectionNPDES) => {
  const validationErrors = [];
  const validRows = [];

  swInspectionNPDES.forEach((item, index) => {
    const validation = validateRowCompleteness(item, index);
    if (!validation.isValid) {
      validationErrors.push(validation);
    } else if (hasAnyData(item)) {
      validRows.push(item);
    }
  });

  if (validationErrors.length > 0) {
    throw new Error(
      "Please complete all required fields in partially filled rows of South Carolina NPDES Permit Additional Information.",
    );
  }

  const processedRows = validRows.map((item) => {
    if (item.date !== "") {
      item.date = getFormatedDate(item.date);
    }
    if (item.discharge !== "") {
      item.discharge = parseInt(item.discharge) === 1 ? true : false;
    }

    if (item.precipitationAmount !== "" && item.precipitationAmount !== null) {
      item.precipitationAmount = parseFloat(item.precipitationAmount);
    } else {
      item.precipitationAmount = null;
    }

    if (item.duration !== "" && item.duration !== null) {
      item.duration = parseInt(item.duration);
    } else {
      item.duration = null;
    }

    return item;
  });

  return processedRows;
};

const isGroundStabilizationRowEmpty = (item) => {
  return (
    !item.area?.trim() &&
    (item.timeLimit === null || item.timeLimit === 0) &&
    item.isStabilizationInstalled === null &&
    (item.stabilization === null || item.stabilization === 0) &&
    (item.groundCover === null || item.groundCover === 0) &&
    (!item.inspectionDate || item.inspectionDate === "") &&
    !item.describeAction?.trim() &&
    (!item.dateCorrecion || item.dateCorrecion === "")
  );
};

const isObservationRowEmpty = (item) => {
  return (
    !item.dischargeOutfall?.trim() &&
    (item.anyIncreaseInStream === null || item.anyIncreaseInStream === 0) &&
    (item.anyVisibleOil === null || item.anyVisibleOil === 0) &&
    (item.anyVisibleErosion === null || item.anyVisibleErosion === 0) &&
    (item.anyVisibleSedimentation === null ||
      item.anyVisibleSedimentation === 0) &&
    (!item.inspectionDate || item.inspectionDate === "") &&
    !item.recommendation?.trim() &&
    (!item.dateCorrection || item.dateCorrection === "")
  );
};

const isNewOrRevisedMeasuresRowEmpty = (item) => {
  return (
    !item.locationAndDesc?.trim() &&
    !item.proposedDimension?.trim() &&
    !item.actualDimension?.trim() &&
    (item.significantDeviation === null || item.significantDeviation === 0) &&
    (!item.measureDate || item.measureDate === "") &&
    (item.measureType === null || item.measureType === 0)
  );
};

const isLotDisturbanceRowEmpty = (item) => {
  return (
    !item.lotNumber?.trim() &&
    (!item.disturbanceDate || item.disturbanceDate === "") &&
    (!item.erosionControlDate || item.erosionControlDate === "")
  );
};

export const filterGroundStabilizationRows = (rows) => {
  if (!Array.isArray(rows) || rows.length === 0) {
    return [];
  }

  const filledRows = rows
    .filter((row) => row && !isGroundStabilizationRowEmpty(row))
    .map((item) => {
      if (item.inspectionDate && item.inspectionDate !== "") {
        item.inspectionDate = getFormatedDate(item.inspectionDate);
      }
      if (item.dateCorrecion && item.dateCorrecion !== "") {
        item.dateCorrecion = getFormatedDate(item.dateCorrecion);
      }
      item.isStabilizationInstalled =
        parseInt(item.isStabilizationInstalled) === 1
          ? true
          : parseInt(item.isStabilizationInstalled) === 2
            ? false
            : null;
      return item;
    });

  // if (filledRows.length === 0 && rows.some((row) => row !== null)) {
  //   const firstValidRow = rows.find((row) => row !== null);
  //   return firstValidRow ? [firstValidRow] : [];
  // }
  return filledRows;
};

export const filterObservationRows = (rows) => {
  if (!Array.isArray(rows) || rows.length === 0) {
    return [];
  }

  const filledRows = rows
    .filter((row) => row && !isObservationRowEmpty(row))
    .map((item) => {
      if (item.inspectionDate && item.inspectionDate !== "") {
        item.inspectionDate = getFormatedDate(item.inspectionDate);
      }
      if (item.dateCorrection && item.dateCorrection !== "") {
        item.dateCorrection = getFormatedDate(item.dateCorrection);
      }
      return item;
    });

  // if (filledRows.length === 0 && rows.some((row) => row !== null)) {
  //   const firstValidRow = rows.find((row) => row !== null);
  //   return firstValidRow ? [firstValidRow] : [];
  // }
  return filledRows;
};

export const filterNewOrRevisedMeasuresRows = (rows) => {
  if (!Array.isArray(rows) || rows.length === 0) {
    return [];
  }

  const filledRows = rows
    .filter((row) => row && !isNewOrRevisedMeasuresRowEmpty(row))
    .map((item) => {
      if (item.measureDate && item.measureDate !== "") {
        item.measureDate = getFormatedDate(item.measureDate);
      }
      return item;
    });

  // if (filledRows.length === 0 && rows.some((row) => row !== null)) {
  //   const firstValidRow = rows.find((row) => row !== null);
  //   return firstValidRow ? [firstValidRow] : [];
  // }
  return filledRows;
};

export const filterLotDisturbanceRows = (rows) => {
  if (!Array.isArray(rows) || rows.length === 0) {
    return [];
  }

  const filledRows = rows
    .filter((row) => row && !isLotDisturbanceRowEmpty(row))
    .map((item) => {
      if (item.disturbanceDate && item.disturbanceDate !== null) {
        item.disturbanceDate = getFormatedDate(item.disturbanceDate);
      }
      if (item.erosionControlDate && item.erosionControlDate !== null) {
        item.erosionControlDate = getFormatedDate(item.erosionControlDate);
      }
      return item;
    });

  // if (filledRows.length === 0 && rows.some((row) => row !== null)) {
  //   const firstValidRow = rows.find((row) => row !== null);
  //   return firstValidRow ? [firstValidRow] : [];
  // }
  return filledRows;
};

export const isRainfallEmpty = (val) =>
  val === undefined ||
  val === null ||
  (typeof val === "string" && val.trim() === "");
